import React, { RefObject, useMemo } from 'react'
import { Badge, IconButton, Tooltip, useTheme } from '@mui/material'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import ClearIcon from '@mui/icons-material/Clear'
import type { GridApiPremium } from '@mui/x-data-grid-premium'

const ResetGridColumns = ({
  apiRef,
  initialVisibilityState,
  onClearVisibility,
}: {
  apiRef: RefObject<GridApiPremium>
  initialVisibilityState: Record<string, boolean>
  onClearVisibility: () => void
}) => {
  const theme = useTheme()

  const isVisibilityChanged = useMemo(() => {
    const current = apiRef.current.getVisibleColumns()
    const allKeys = new Set([...Object.keys(current), ...Object.keys(initialVisibilityState)])
    return Array.from(allKeys).some(key => current[key] !== initialVisibilityState[key])
  }, [apiRef, initialVisibilityState])

  return (
    <Tooltip title={isVisibilityChanged ? 'Reset Columns' : ''}>
      <IconButton
        sx={{
          color: isVisibilityChanged ? 'text.primary' : 'text.tertiary',
          borderRadius: 0,
        }}
        disabled={!isVisibilityChanged}
        onClick={onClearVisibility}
      >
        <Badge
          badgeContent={
            <ClearIcon
              sx={{
                fontSize: 18,
                color: isVisibilityChanged ? 'text.error' : 'text.secondary',
              }}
            />
          }
        >
          <ViewColumnIcon
            sx={{
              fontSize: 30,
              color: isVisibilityChanged ? 'text.primary' : 'text.secondary',
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default ResetGridColumns
